import {admissionStatusTypes, admissionViewTypes, bookAdmissionToggleStyles, CalendarViews} from '../bookedAdmissions';
import AgyleToggleButtons from "../../../components/ui/buttons/agyleToggleButtons";
import React, {useEffect, useRef, useState} from 'react';
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import AdmissionPatientCard from "./../admissionPatientCard";
import {useDispatch, useSelector} from "react-redux";
import {
    geFtiltersStatus,
    getAdmissionType,
    getConfig,
    getFilterAnaestheticType,
    getFilterPriority,
    getFiltersStatus,
    getHourHeight,
    getMarkedOperation,
    getOperations,
    getOperationsFiltered,
    getOperationsStatus,
    getOperationToScroll,
    getSpecialtiesFilter,
    getUnscheduledLength,
    getUnscheduledOperations,
    loadNextUnscheduledOperations,
    loadUnscheduledOperations,
    setContentView,
    setFilterAnaestheticType,
    setFilterPriority,
    setFiltersStatus,
    setMarkedOperation,
    setOperationsStatus,
    setOperationToScroll,
    setSpecialtiesFilter,
    getPatientsListToReschedule,
    getCalendarView,
    getDraftModeOn,
    getProcedureFilter,
    setProcedureFilter,
    getPatientsFilter,
    setPatientFilter,
    clearFilters,
    getConsultantsFilter,
    setConsultantsFilter,
    getSurgeonsFilter,
    getAnaesthetistsFilter, setSurgeonsFilter, setAnaesthetistsFilter,
} from '../../../store/reducers/booked_admissions';
import $ from "jquery";
import {admissionDnD, setAdmissionDnD} from '../../../store/reducers/dragAndDrop';
import {proceduresLen} from '../../bookAdmission/workList';
import {agylePref} from '../../../store/reducers/preferences';
import TuneIcon from '@mui/icons-material/Tune';
import {
    AdmissionConsultant,
    AdmissionSpecialties,
} from '../../../controls/agyle/dictionaries';
import Grid from '@mui/material/Grid';
import {CircularProgress, MenuItem, TextField} from '@mui/material';
import AgyleSelectField from '../../../components/ui/selector/agyleSelectField';
import ClearIcon from '@mui/icons-material/Clear';
import withStyles from '@mui/styles/withStyles';
import Badge from "@mui/material/Badge";
import moment from "moment/moment";
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/resizable';
import 'jquery-ui/themes/base/draggable.css';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/draggable';
import {Autocomplete} from '@mui/lab';
import * as _ from 'lodash';
import {hasBAPermission, Permissions} from '../../../store/reducers/user';
import SearchIcon from "@mui/icons-material/Search";
import {useDebounce} from 'use-debounce';
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from '@mui/icons-material/Close';
import {contentViewTypes} from '../content/content';
import {useTheme} from '@mui/material/styles';

export const StyledBadgeAdmission = withStyles((theme) => ({
    badge: {
        right: 1,
        top: 1,
        padding: "0 4px",
    },
    dot: {},
}))(Badge);

export const StatusTypes = {
    ACTIVE: "active",
    CANCELED: "canceled",
}
export const StatusReschedule = {
    ASSIGNED: "assigned",
    UNASSIGNED: "unassigned",
}


export const useStyles = makeStyles((theme) => ({
    statusItem: {
        width: "50%",
        textAlign: "center",
        color: "grey",
        cursor: "pointer",
        padding: 5,
        fontSize: 12,
        borderBottom: "1px solid "+theme.palette.background.default,
    },
    itemSelected: {
        borderBottom: "1px solid "+theme.palette.primary.main,
        color: theme.palette.primary.main,
        transition: "border 0.6s linear"
    },
    patientsCounter: {
        fontSize: 14,
        padding: "10px 10px 10px 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    filterIcons: {
        gap: 10,
        display: "flex"
    },
    counter: {
        background: theme.palette.admissionForm.toggleBackground,
        borderRadius: 7,
        padding: 5,
        marginLeft: 8,
        minWidth: 29,
        height: 29,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center"
    },
    chipTag: {
        background: "#3D3E40",
        borderRadius: 10,
        fontSize: 12,
        padding: 5,
        display: "inline-flex",
        alignItems: "center",
        gap: 10

    },
    patientList: {
        width: 300,
        marginRight: 10
    },
    typeContainer: {
        width: "100%",
        display: "flex",
        margin: "15px 0 15px 0"
    },
    overseeingConsultant: {

        "& .MuiSelect-select": {
            padding: "7.5px 14px"
        }
    },
    menuPaper: {
        maxHeight: 300,
    },
    filterLabel: {
        fontSize: 14,
     //   paddingLeft: 10,
        display: "flex",
        alignItems: "center"
    },
    clearFilterButton: {
        color: "#2180F7",
        fontSize: 12,
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer"
    },
    filterCounter: {
        background: "#2280f7",
        color: "white",
        borderRadius: 20,
        padding: 5,
        marginLeft: 10,
        minWidth: 29,
        height: 29,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center"
    },
    textFieldClass: {
        marginRight: 5,
        marginTop: 10,
        // width: 150
    }

}));


const PatientsList = (props) => {
    const classes = useStyles();
    const baToggleClasses = bookAdmissionToggleStyles();
    const dispatch = useDispatch();
    const theme = useTheme();

    const status = useSelector(getFiltersStatus);
    const operations = useSelector(getOperationsFiltered);
    const unscheduledOperations = useSelector(getUnscheduledOperations);
    const unscheduledLength = useSelector(getUnscheduledLength);

    const admissionStatus = useSelector(getOperationsStatus);
    const specialtiesFilter = useSelector(getSpecialtiesFilter);
    const consultantsFilter = useSelector(getConsultantsFilter);
    const patientsFilter = useSelector(getPatientsFilter);
    const surgeonsFilter = useSelector(getSurgeonsFilter);
    const anaesthetistsFilter = useSelector(getAnaesthetistsFilter);

    const priority =  useSelector(getFilterPriority);
    const anaestheticType = useSelector(getFilterAnaestheticType)
    const admissionType = useSelector(getAdmissionType);
    const procedureFilter = useSelector(getProcedureFilter);

    const agylePreference = useSelector(agylePref);
    const config = useSelector(getConfig);
    const markedOperation = useSelector(getMarkedOperation);
    const operationToScroll = useSelector(getOperationToScroll);

    const patientsListToReschedule = useSelector(getPatientsListToReschedule);
    const calendarView = useSelector(getCalendarView);

    const [unscheduledPageNumber, setUnscheduledPageNumber] = React.useState(1);
    const [loading, setLoading] = useState(false);
    const [cardConfig, setCardConfig] = React.useState();
    const [filtersVisible, setFilterVisible] = React.useState(false);

    const [rescheduleStatus, setRescheduleStatus] = useState(StatusReschedule.ASSIGNED)

    const hourHeight = useSelector(getHourHeight);

    useEffect(() => {
        setLoading(false);
        setLoadingSearch(false);
    },[unscheduledOperations])

    useEffect(()=>{
        setFilterVisible(false)
    },[admissionType]);

    const draftMode = useSelector(getDraftModeOn);

    const userCanManageUnscheduledList = () => {
        if(admissionViewTypes.THEATRES === admissionType) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_TCI_UL, admissionType));
        if(admissionViewTypes.MDU === admissionType) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_MDU_UL, admissionType));
    }

    const handlePointerStart = (e, item) => {

        //if(markedOperation && markedOperation.id === item.id && !draftMode && userCanManageUnscheduledList()) {
        if(!draftMode && userCanManageUnscheduledList()) {
            e.preventDefault();
            e.stopPropagation();

            if (item.patient !== null && (admissionStatus === admissionStatusTypes.UNSCHEDULED || rescheduleStatus === StatusReschedule.UNASSIGNED)) {
                let el = $(`#${item.id}`);
                let elClone = el.clone();

                elClone.css({
                    height: `${proceduresLen(item) / 30 * (hourHeight/2) - 2}px`,
                    width: 200,
                    overflow: "hidden"
                });

                const ghost = $("#dandd");
                ghost.css("display", "none");
                $("#dandd_2").css("display", "none");
                ghost.html(elClone);

                dispatch(setMarkedOperation(item))
                dispatch(setAdmissionDnD({
                    item
                }));
            } else {

            }
        }
    };



    const scrollToOperation = (type) => {
        if (admissionStatus === type && !dontScroll.current) {
            if (operationToScroll && document.getElementById("card_" + operationToScroll)) {
                document.getElementById("card_" + operationToScroll).scrollIntoView({ block: 'center' });
            }
        } else {
            dontScroll.current = false;
        }
    }

    useEffect(() => {
        scrollToOperation(admissionStatusTypes.SCHEDULED)
    }, [operationToScroll, operations]);

    useEffect(() => {
        scrollToOperation(admissionStatusTypes.UNSCHEDULED)
    }, [operationToScroll, unscheduledOperations]);

    const [timeFormat, setTimeFormat] = useState(false);

    useEffect(()=> {
        if(config) {
            let configType = admissionStatus === admissionStatusTypes.SCHEDULED? "tciScheduleList": "tciUnscheduledList";
            let configCard = config.cardSetting[configType];
            let timeFormatInMin = config.timeFormatInMinutes;

            if(agylePreference.bookedAdmissionsCardConfig[configType])
                configCard = agylePreference.bookedAdmissionsCardConfig[configType]

            if(agylePreference.bookedAdmissions.timeFormatInMinutes !== null)
                timeFormatInMin = agylePreference.bookedAdmissions.timeFormatInMinutes

            setCardConfig(configCard);
            setTimeFormat(timeFormatInMin);
        }


    },[admissionStatus, config, agylePreference])


    const handleToggleFilterButton  = () => {
        setFilterVisible(!filtersVisible)
    }

    const filterScheduleList = (operations) => {
        if(admissionType === admissionViewTypes.THEATRES) {

            let filterOp = operations;

            if(priority.length) {
                filterOp = filterOp.filter((op) => {return priority.some((p) => {
                    return op.priority && p.code === Number(op.priority.code)
                })});
            }

            if(anaestheticType.length) {
                filterOp = filterOp.filter((op) => {return anaestheticType.some((a) => {
                    return op.anaestheticType && a.code === Number(op.anaestheticType.code)
                })});
            }

            if(specialtiesFilter.length) {
                filterOp = filterOp.filter((op) => {return op.procedures.some((procedure) => {
                    return specialtiesFilter.some((pfilter) => {return pfilter.__code === procedure.specialty});
                })});
            }
            if(consultantsFilter.length) {
                filterOp = filterOp.filter((op) => {return consultantsFilter.some((consultant) => {
                    return consultant.id === op.overseeingConsultant?.id
                })});
            }

            if(patientsFilter) {
                let filterArray = patientsFilter.split(" ");

                let patternDOB = /\d{2}\/\d{2}\/\d{4}/;
                let hospitalNumbers = filterArray.filter((f) => f.match(/[0-9]/)).filter((f) => !f.match(patternDOB));
                let dob = filterArray.filter((f) => f.match(patternDOB));
                let names = filterArray.filter((f) => !f.match(/[0-9]/)).filter((f) => !f.match(patternDOB));

                if(dob.length){
                    filterOp = filterOp.filter((op) => {return dob.some((a) => {
                        return a === moment(op.patientDob).format("MM/DD/YYYY")
                    })});
                }
                if(hospitalNumbers.length) {
                    filterOp = filterOp.filter((op) => {return hospitalNumbers.some((a) => {
                        return a === op.patientId
                    })});
                }

                if(names.length) {
                    const regex = new RegExp(names.join("|"), "i");
                    filterOp = filterOp.filter((op) => regex.test(op.patientName));
                }

            }

            return filterOp;

        } else {
            if(!procedureFilter)
                return operations;
            else
                return operations.filter((op) => {return op.procedures.some((procedure) => {return procedureFilter.__id === procedure.__id})});
        }
    }

    const getPatientList = () => {
        if(admissionStatus !== admissionStatusTypes.SCHEDULED) return unscheduledOperations;
        if(admissionType === admissionViewTypes.THEATRES || calendarView === CalendarViews.month || patientsListToReschedule.length === 0) return filterScheduleList(operations);

        if(patientsListToReschedule.length !== 0) {
            let filterList = patientsListToReschedule.filter((item) => {
                return rescheduleStatus === StatusReschedule.UNASSIGNED?
                    !item.operationSessionDetails.workStationId : item.operationSessionDetails.workStationId;
            })

            return filterScheduleList(Array.from(filterList, (item) => item.operation));
        }

    }

    const getListLength = () => {
        if(patientsListToReschedule.length !== 0) {
            let filterList = patientsListToReschedule.filter((item) => {
                return rescheduleStatus === StatusReschedule.UNASSIGNED?
                    !item.operationSessionDetails.workStationId : item.operationSessionDetails.workStationId;
            })
            return filterScheduleList(Array.from(filterList, (item) => item.operation)).length;
        }

        return admissionStatus === admissionStatusTypes.SCHEDULED? filterScheduleList(operations)?.length : unscheduledLength || 0
    }

    useEffect(() => {
        setUnscheduledPageNumber(1);
        if(document.getElementById("list-scroll")) {
            document.getElementById("list-scroll").scrollTop = 0;
            let chipsHeight = document.getElementById("chips")?.offsetHeight || 1;
            document.getElementById("list-scroll").style.height = `calc(100vh - 235px - ${searchVisible? 50: 0}px - ${chipsHeight}px )`

        }

        setLoadingSearch(true);


        dispatch(loadUnscheduledOperations());

    },[anaestheticType, priority, patientsFilter, consultantsFilter, specialtiesFilter, status, procedureFilter])


    const getPatientListConfig = () => {
        let configType = "";
        if(admissionType === admissionViewTypes.THEATRES)
            configType = admissionStatus === admissionStatusTypes.SCHEDULED? "tciScheduleList": "tciUnscheduledList";
        else
            configType = admissionStatus === admissionStatusTypes.SCHEDULED? "mduScheduleList": "mduUnscheduledList";

        let configCard = config?.cardSetting[configType];

        if(agylePreference.bookedAdmissionsCardConfig[configType])
            configCard = agylePreference.bookedAdmissionsCardConfig[configType]

        return configCard;
    }

    const renderCustomOptionPriority = (c) => {
        return (<MenuItem value={c} key={c.code}> {c.description} </MenuItem>);
    };

    const getFilterLength = () => {
        if(admissionType === admissionViewTypes.THEATRES) return (specialtiesFilter? 1 : 0) + priority?.length + anaestheticType?.length + consultantsFilter?.length;
        else return procedureFilter? 1: 0;
    }

    const [proceduresDict, setProceduresDict] = React.useState([]);

    useEffect(()=>{
        const proceduresDict = _.filter(props.proceduresDict, (dictItem) => {
            if(_.find(dictItem.systype, {"code": "MDU"})){
                    return dictItem;
            }
        });

        setProceduresDict(proceduresDict);
    }, [props.proceduresDict]);



    useEffect(()=>{
        const handleSave = (event) => {
            if ((event.ctrlKey || event.metaKey) && event.key === 's') {
                event.preventDefault();
                setSearchVisible((s)=> !s);
            }
        };

        window.addEventListener('keydown', handleSave);

        return () => {
            window.removeEventListener('keydown', handleSave);
        };

    },[])

    const renderMduFilters = () => {
        return <div>
            <div className={classes.patientsCounter}>
                <div className={classes.filterLabel}> Filtering Options <div className={classes.filterCounter}> {getFilterLength()} </div></div>
                <ClearIcon  onClick={handleToggleFilterButton} fontSize="small"/>
            </div>
            <Grid container spacing={2} style={{marginBottom: 15, width: "99%"}}>

            <Grid item xs={12}>
                <Autocomplete
                    id={"combo-box-dicts-procedure-select"}
                    options={proceduresDict}
                    sx={{ m: 0, width: '100%' }}
                    renderInput={(params) => <TextField {...params} label="Select procedure" placeholder="Type to see more records" />}
                    getOptionLabel={option => (option?.__description? option?.__description: option?.description)+" ("+option.specialty+")"}
                    isOptionEqualToValue={(option, value) => option?.__description === value?.__description}
                    value={procedureFilter}
                    onChange={(event, selected, reason) => {
                        dispatch(setProcedureFilter(selected));
                    }}
                />
            </Grid>
        </Grid>
        </div>
    }

    const renderTheatersFilters = () => {
        return <div>
            <div className={classes.patientsCounter}>
                <div className={classes.filterLabel}> Filtering Options <div className={classes.filterCounter}> {getFilterLength()} </div></div>
                <ClearIcon  onClick={handleToggleFilterButton} fontSize="small"/>
            </div>
            <Grid container spacing={2} style={{marginBottom: 15, paddingLeft: 10, width: "99%"}}>

                <Grid item xs={12}>
                    <div className={classes.clearFilterButton} onClick={()=>{   dispatch(clearFilters());}}>
                        <CloseIcon fontSize={"small"}/>
                        Clear Filters
                    </div>
                </Grid>

                {admissionType === admissionViewTypes.THEATRES &&
                <Grid item xs={12}>
                    <AdmissionSpecialties
                        name="AdmissionSpecialties"
                        label={"Specialties"}
                        color="primary"
                        size={"small"}
                        value={specialtiesFilter}
                        inputProps={{
                            style: {
                                borderRadius: 10
                            },
                        }}
                        onChange={(e) => dispatch(setSpecialtiesFilter(e))}
                    />
                </Grid>
                }
                <Grid item xs={12}>
                    {admissionType === admissionViewTypes.THEATRES && <AdmissionConsultant
                        name="AdmissionConsultant"
                        label={"Overseeing Consultant"}
                        color="secondary"
                        style={{background: theme.palette.mode === 'light' ? '#00000014': '#ffffff29'}}
                        size={"small"}
                        disableClearable
                        multiple
                        value={consultantsFilter}
                        onChange={(el) => {
                            dispatch(setConsultantsFilter(el))
                        }}
                    />
                    }
                </Grid>
                <Grid item xs={12}>
                    <AgyleSelectField
                        onChange={(p)=>{dispatch(setFilterPriority(p))}}
                        name={"priority"}
                        options={config?.priority}
                        value={priority}
                        withBorder
                        multiple
                        withLabel={false}
                        label={"Priority"}
                        withBackground
                        padding = {"10px 5px"}
                        defaultClearValue={[]}
                        customObject={renderCustomOptionPriority}
                        clearButtonVisible
                    />

                </Grid>
                <Grid item xs={12}>
                    <AgyleSelectField
                        onChange={(a)=>{dispatch(setFilterAnaestheticType(a))}}
                        name={"anaestheticType"}
                        options={config?.anaestheticType}
                        value={anaestheticType}
                        withBorder
                        multiple
                        padding = {"10px 5px"}
                        label={"Anaesthetic Type"}
                        withBackground
                        defaultClearValue={[]}
                        customObject={renderCustomOptionPriority}
                        clearButtonVisible
                    />
                </Grid>
            </Grid>
        </div>

    }

    const renderFilters = () => {
        switch (admissionType){
            case admissionViewTypes.THEATRES:
                return renderTheatersFilters();
            case admissionViewTypes.MDU:
                return renderMduFilters();
        }

    }

    useEffect(() => {
        if(unscheduledPageNumber !== 1)
            dispatch(loadNextUnscheduledOperations(unscheduledPageNumber));
    },[unscheduledPageNumber])


    const handleScrollList = (e) => {
        if(admissionStatus === admissionStatusTypes.UNSCHEDULED) {
            const isBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 800; // e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
            if (isBottom && !loading) {
                dontScroll.current = true;
                setLoading(true);
                setUnscheduledPageNumber((page) => (page + 1));
            }
        }
    }

    const dontScroll = useRef(false);

    const getAdmissionStatus = () => {
        let s = [];
        if(admissionType === admissionViewTypes.THEATRES) s.push({value: admissionStatusTypes.WORKLIST, label: "Worklist"});
        s.push( {value: admissionStatusTypes.UNSCHEDULED, label: "Unscheduled", disabled: patientsListToReschedule.length !== 0});
        s.push( {value: admissionStatusTypes.SCHEDULED, label: "Scheduled"})
        return s
    }

    const getMDUStatus = () => {
        let s = [];
        s.push( {value: StatusReschedule.ASSIGNED, label: "Assigned"});
        s.push( {value: StatusReschedule.UNASSIGNED, label: "Unassigned"})
        return s
    }


    const showMduReassignedTabs = () => {
        return admissionStatus === admissionStatusTypes.SCHEDULED && admissionType === admissionViewTypes.MDU &&
            calendarView !== CalendarViews.month && patientsListToReschedule.length !== 0
    }

    const [searchVisible, setSearchVisible] = useState(patientsFilter);

    const [input, setInput] = useState("");
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [inputValueDebounced] = useDebounce(input, 1000);

    useEffect(()=>{
        dispatch(setPatientFilter(inputValueDebounced))
    }, [inputValueDebounced])


    const removeConsultant  = (consultant) => {
        let newConsultant = [];
        newConsultant = consultantsFilter.filter((el) => el.id !== consultant.id)
        dispatch(setConsultantsFilter(newConsultant))
    }

    const removeSurgeon  = (surgeon) => {
        let newSurgeons = [];
        newSurgeons = surgeonsFilter.filter((el) => el.id !== surgeon.id)
        dispatch(setSurgeonsFilter(newSurgeons))
    }

    const removeAnaesthetist  = (anaesthetist) => {
        let newAnaesthetist = [];
        newAnaesthetist = anaesthetistsFilter.filter((el) => el.id !== anaesthetist.id)
        dispatch(setAnaesthetistsFilter(newAnaesthetist))
    }

    const removeSpecialties = (speciality) => {
        let newSpecialties = [];
        newSpecialties = newSpecialties.filter((el) => el.__id !== speciality.__id)
        dispatch(setSpecialtiesFilter(newSpecialties))
    }

    const removePriority = (priorityItem) => {
        let newPriority = [];
        newPriority = priority.filter((el) => el.description !== priorityItem.description)
        dispatch(setFilterPriority(newPriority));
    }

    const removeAnaesthetic = (anaesthetic) => {
        let newAnaesthetic = [];
        newAnaesthetic = anaestheticType.filter((el) => el.description !== anaesthetic.description)
        dispatch(setFilterAnaestheticType(newAnaesthetic));
    }

    const removeProcedure = (procedure) => {
        let newProcedure = [];
        newProcedure = procedureFilter.filter((el) => el.description !== procedure.description)
        dispatch(setProcedureFilter(newProcedure));
    }

    return(<div className={classes.patientList}>
        {!showMduReassignedTabs() && <div>
            <AgyleToggleButtons
                classNameRoot={baToggleClasses.baToggle_classNameRoot}
                classNameLabel={baToggleClasses.baToggle_classNameLabel}
                classNameSelected={baToggleClasses.baToggle_classNameSelected}
                onChange={(e) => {
                    if (e) dispatch(setOperationsStatus(e))
                }}
                value={admissionStatus}
                size="small"
                options={getAdmissionStatus()}
                minWidth={300 / getAdmissionStatus().length}
            />
        </div>
        }
        {showMduReassignedTabs() &&
            <div>
                <AgyleToggleButtons
                    classNameRoot={baToggleClasses.baToggle_classNameRoot}
                    classNameLabel={baToggleClasses.baToggle_classNameLabel}
                    classNameSelected={baToggleClasses.baToggle_classNameSelected}
                    onChange={(e) => {
                        if (e) setRescheduleStatus(e);
                    }}
                    value={rescheduleStatus}
                    size="small"
                    options={getMDUStatus()}
                    minWidth={300 / getMDUStatus().length}
                />
            </div>
        }

        {admissionStatus === admissionStatusTypes.UNSCHEDULED &&
            <div className={classes.typeContainer}>
                <div className={clsx(status === StatusTypes.ACTIVE && classes.itemSelected, classes.statusItem)}
                     onClick={() => dispatch(setFiltersStatus(StatusTypes.ACTIVE))}>
                    Active
                </div>
                <div className={clsx(status === StatusTypes.CANCELED && classes.itemSelected, classes.statusItem)}
                     onClick={() => dispatch(setFiltersStatus(StatusTypes.CANCELED))}>
                    Deleted
                </div>
            </div>
        }

        {admissionStatus === admissionStatusTypes.SCHEDULED &&
                <div style={{height: 59}}/>
        }

        {filtersVisible && renderFilters()}

        {!filtersVisible &&
            <>
                <div className={classes.patientsCounter}>
                    <div>{admissionStatus} Surgeries <div className={classes.counter}>
                        {getListLength()} </div>
                    </div>
                    <div className={classes.filterIcons}>
                        <StyledBadgeAdmission
                            variant="dot"
                            invisible={!patientsFilter}
                            color={"primary"}>
                            <SearchIcon fontSize="small" color={searchVisible? "primary": "inherit"} onClick={()=>{setSearchVisible(!searchVisible)}}/>
                        </StyledBadgeAdmission>

                        {admissionType !== admissionViewTypes.THEATRES && <StyledBadgeAdmission
                            badgeContent={getFilterLength()}
                            color={"primary"}>
                            <TuneIcon fontSize="small" onClick={handleToggleFilterButton}/>
                        </StyledBadgeAdmission>
                        }
                    </div>


                </div>

                {searchVisible &&
                    <TextField
                        size="small"
                        variant="outlined"
                        placeholder={"Names MM/DD/YYYY Hospital Number"}
                        className={"custom-dt"}
                        style={{ width: "100%" }}
                        autoFocus
                        id={"search_patients"}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end" style={{cursor: "pointer"}}>
                                    {loadingSearch &&  <CircularProgress size={20} style={{marginRight: 5}} /> }
                                    {patientsFilter &&
                                        <ClearIcon onClick={()=>{
                                            document.getElementById("search_patients").value = "";
                                            dispatch(setPatientFilter(""))
                                        }} />
                                    }
                                </InputAdornment>
                            ),
                        }}
                        name={"patientSearch"}
                        defaultValue={patientsFilter}
                        onChange={(e)=> {setInput(e.target.value)}}
                        onKeyDown={(ev) => {
                            if (ev.key === 'Enter') {
                                dispatch(setPatientFilter(ev.target.value))
                                ev.preventDefault();
                            }
                        }}
                        onBlur={(e)=>{dispatch(setPatientFilter(e.target.value))}}
                    />
                }

                {admissionType === admissionViewTypes.THEATRES && <div id={"chips"} style={{display: "flex", gap: 5, flexWrap: "wrap"}}>
                    {consultantsFilter.map((consultant) => {
                        return <div className={classes.chipTag} style={{background: "#3E5C61"}}> {consultant.name}
                            <CloseIcon fontSize={"small"} onClick={() => {
                                removeConsultant(consultant)
                            }}/></div>
                    })}
                    {specialtiesFilter.map((s) => {
                        return <div className={classes.chipTag} style={{background: "#523E61"}}> {s.__code}
                            <CloseIcon fontSize={"small"} onClick={() => {
                                removeSpecialties(s)
                            }}/>
                        </div>
                    })}
                    {surgeonsFilter.map((surgeon) => {
                        return <div className={classes.chipTag} style={{background: "#40613e"}}> {surgeon.name}
                            <CloseIcon fontSize={"small"} onClick={() => {
                                removeSurgeon(surgeon)
                            }}/></div>
                    })}
                    {anaesthetistsFilter.map((anaesthetist) => {
                        return <div className={classes.chipTag} style={{background: "#61593e"}}> {anaesthetist.name}
                            <CloseIcon fontSize={"small"} onClick={() => {
                                removeAnaesthetist(anaesthetist)
                            }}/></div>
                    })}
                    {priority.map((p) => {
                        return <div className={classes.chipTag}> {p.description}
                            <CloseIcon fontSize={"small"} onClick={() => {
                                removePriority(p)
                            }}/>
                        </div>
                    })}
                    {anaestheticType.map((a) => {
                        return <div className={classes.chipTag}> {a.description}
                            <CloseIcon fontSize={"small"} onClick={() => {
                                removeAnaesthetic(a)
                            }}/>
                        </div>
                    })}
                    {/*{procedureFilter.map((p)=>{ return <div className={classes.chipTag}> {p.description}*/}
                    {/*    <CloseIcon fontSize={"small"} onClick={()=>{removeProcedure(p)}}/>*/}
                    {/*</div>})}*/}

                </div>
                }

                <div className={"scroll-normal-white"}
                     id={"list-scroll"}
                     onScroll={handleScrollList} style={{height: `calc(100vh - 235px - ${searchVisible? 50: 0}px)`, overflow: "auto", marginTop: 10}}>
                    {cardConfig && getPatientList()?.map((ad, index) => (
                        <div key={index+"patientList"}
                            onClick={(e) => {
                                dispatch(setMarkedOperation(ad));
                                if(ad.bookedSession) {
                                    dontScroll.current = true;
                                }
                            }}
                            onDoubleClick={(e)=>{
                                dispatch(setMarkedOperation(ad));
                                dispatch(setContentView(contentViewTypes.INFORMATION))}
                            }
                            style={{marginBottom: 10}}
                             onPointerDown={(e) => {
                                handlePointerStart(e, ad)
                            }}
                        >
                            <AdmissionPatientCard
                                cardName={"LIST"}
                                markedOperation={markedOperation ? markedOperation.id === ad.id : false}
                                cardConfig={getPatientListConfig()}
                                timeFormat={timeFormat}
                                ad={ad} index={index}/>
                        </div>
                    ))}
                </div>
            </>

        }

    </div>)
};

export default PatientsList;